function transformTranslationsToSnake(translations = {}) {
  const mapKey = {
    title: 'title',
    titleColor: 'title_color',
    subTitle: 'sub_title',
    subTitleColor: 'sub_title_color',
    buttonText: 'button_text',
    buttonTextColor: 'button_text_color',
    buttonBgColor: 'button_bg_color',
    buttonLink: 'button_link',
  };

  return Object.entries(translations).reduce((translationsByLang, [language, fields = {}]) => {
    translationsByLang[language] = Object.entries(mapKey).reduce((snakeCaseFields, [camelKey, snakeKey]) => {
      snakeCaseFields[snakeKey] = fields[camelKey] ?? null;

      return snakeCaseFields;
    }, {});

    return translationsByLang;
  }, {});
}

export default function createBannerRequestBody(form) {
  const body = {
    place: form.place,
    type: form.type || 'custom',
    content: form.content || '',
    scroll_delay: form.scrollDelay || 0,
  };

  if (form.place === 'private_offers') {
    body.name = form.name || '';
  } else if (form.name) {
    body.name = form.name;
  }

  body.informations = (form.informations || []).map((info, i) => {
    const item = {
      background_color: info.backgroundColor || '',
      sorting: Number.isFinite(info.sorting) ? info.sorting : i,
      translations: transformTranslationsToSnake(info.translations || {}),
    };

    if (form.id && info.id) {
      item.id = info.id;
    }

    if (info.backgroundImage === null) {
      item.background_image = null;
    } else if (
      info.backgroundImage instanceof File
      || typeof info.backgroundImage === 'string'
    ) {
      item.background_image = info.backgroundImage;
    }

    if (info.image === null) {
      item.image = null;
    } else if (
      info.image instanceof File
      || typeof info.image === 'string'
    ) {
      item.image = info.image;
    }

    return item;
  });

  return body;
}
